<template>
  <div class="container-fluid mainPage">
    <app-mainPageCarousel></app-mainPageCarousel>

    <app-companyinfo></app-companyinfo>
    <app-footer />
  </div>
</template>
<script>
import Carousel from "../components/mainPage/Carousel.vue";
import CompanyInfo from "../components/mainPage/CompanyInfo.vue";
import Footer from "../components/common/Footer.vue";
export default {
  data() {
    return {};
  },
  components: {
    "app-mainPageCarousel": Carousel,
    "app-companyinfo": CompanyInfo,
    "app-footer": Footer
  }
};
</script>
<style scoped>
.mainPage {
  padding-right: 0;
  padding-left: 0;
}
</style>
